export default __webpack_public_path__ + "static/media/thumbnail3.379f64a7.jpg";